import { 
	Datagrid, 
	List, 
	TextField, 
	NumberField, 
	BooleanField, 
	DateField,
	ReferenceField,
	EditButton,
	ShowButton
} from 'react-admin';

const DatingEventCouponList = () => (
	<List title="קופונים לאירועי דייטינג" resource="events-coupons">
		<Datagrid rowClick="edit" style={{ textAlign: 'right' }}>
			<TextField source="code" label="קוד קופון" textAlign="right" dir="ltr" />
			<TextField source="eventId.title" label="אירוע דייטינג" textAlign="right" dir="rtl" />
			<DateField source="eventId.time" label="תאריך האירוע" showTime locales="he-IL" />
			<TextField source="isUsed.email" label="שימוש" />
			<DateField source="createdAt" label="נוצר בתאריך" showTime locales="he-IL" />
			<DateField source="updatedAt" label="עודכן בתאריך" showTime locales="he-IL" />
			<EditButton />
			<ShowButton />
		</Datagrid>
	</List>
);

export default DatingEventCouponList;
